<div class="contact-form grid grid-cols-12 gap-4px">
  <app-horizontal-selector class="col-span-12 md:col-span-6" [data]="genders" [index]="genderIndex"
    (indexChange)="updateGender($event)">
    <ng-template let-gender>
      {{('CONTACT_FORM.GENDER.' + gender) | uppercase | translate}}
    </ng-template>
  </app-horizontal-selector>
  <input class="col-span-12 md:col-span-6" type="text" [placeholder]="'CONTACT_FORM.COMPANY' | translate"
    [formControl]="form.controls.company">
  <label class="col-span-12 md:col-span-6 required">
    <input class="w-full" type="text" [placeholder]="'CONTACT_FORM.FIRSTNAME' | translate"
      [formControl]="form.controls.firstname">
  </label>
  <label class="col-span-12 md:col-span-6 required">
    <input class="w-full" type="text" [placeholder]="'CONTACT_FORM.LASTNAME' | translate"
      [formControl]="form.controls.lastname">
  </label>
  <label class="col-span-12 required">
    <input class="w-full" type="email" [placeholder]="'CONTACT_FORM.EMAIL' | translate"
      [formControl]="form.controls.from">
  </label>
  <label class="col-span-12 required">
    <input class="w-full" type="text" [placeholder]="'CONTACT_FORM.SUBJECT' | translate"
      [formControl]="form.controls.subject">
  </label>
  <label class="col-span-12 required">
    <textarea class="w-full" rows="8" cols="50" [placeholder]="'CONTACT_FORM.MESSAGE' | translate"
      [formControl]="form.controls.text"></textarea>
  </label>

  <span
    class="col-start-1 col-span-12 xl:col-start-7 xl:col-span-6 xl:text-right mt-16px mb-28px xl:mt-16px xl:mb-0px">{{'CONTACT_FORM.MANDATORY'
    | translate}}</span>

  <div class="flex flex-row col-span-12 xl:col-span-6 col-start-1 xl:row-start-6 xl:mt-16px">
    <app-checkbox [control]="form.controls.isPrivacyChecked">
      <span>{{'CONTACT_FORM.ACCEPT_PRIVACY_STATEMENT' | translate}}</span>
      <a [routerLink]="['/privacy-policy']" target="_blank">{{ 'CONTACT_FORM.PRIVACY_STATEMENT' | translate }}</a>
    </app-checkbox>
  </div>

  <div class="flex flex-row col-span-12 justify-center flex-1">
    <app-cta-button [class.disabled]="isSendTriggered" class="flex justify-center col-span-12 mt-36px xl:mt-48px"
      [label]="'CONTACT_FORM.SUBMIT' | translate" (click)="send($event)"></app-cta-button>
  </div>

  <div *ngIf="isOverlayOpen" class="overlay">
    <button>
      <div class="icon" [inlineSVG]="'assets/icons/icon28-close.svg'" (click)="closeMessage()"></div>
    </button>
    <span *ngIf="isSuccess">{{'CONTACT_FORM.SUCCESSFULLY_SENT' | translate}}</span>
    <span *ngIf="isError">{{'CONTACT_FORM.FAILED_SENT' | translate}}</span>
  </div>

</div>